import { render } from "./NewsletterComponent.vue?vue&type=template&id=7a3ebc12&scoped=true"
const script = {}

import "./NewsletterComponent.vue?vue&type=style&index=0&id=7a3ebc12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3ebc12"]])

export default __exports__